import * as React from 'react';
import TaskPane from './ui/components/TaskPane';

const App: React.FC = () => {
  return <TaskPane />;
};

export default App;

